define([
	"dojo/_base/declare"
], function(declare) {

	return declare(null, {
		/** @property {boolean} customErrorHandling - if true then perform the custom error handling, otherwise deal with by default */
		customErrorHandling: false,

		/**
		 * Deal with the message depending on the customErrorHandling, if true, it will forward to custom approach
		 * @param {string} message
		 */
		displayMessage: function(message) {
			if (!this.customErrorHandling) {
				this.inherited(arguments);
			}
		},

		/**
		 * Notify the receiver with new message
		 * @param {string} message
		 */
		onErrorMessage: function(message) { },

		/**
		 * Override to watch the message property and publish notify
		 */
		postCreate: function() {
			var self = this;

			this.watch("message", function(attr, oldValue, newValue) {
				self.onErrorMessage(newValue);
			});

			this.inherited(arguments);
		}
	});
});